import { render, staticRenderFns } from "./CompanyDetailsView.vue?vue&type=template&id=1fb76ad9&scoped=true&"
import script from "./CompanyDetailsView.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb76ad9",
  null
  
)

export default component.exports